import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { RequireAuth } from "./auth/RequireAuth";
import { LoginPage } from "./pages/LoginPage";
import { DeviceListPage } from "./pages/DeviceListPage";
import { EnrollmentPage } from "./pages/EnrollmentPage";
import { SessionPage } from "./pages/SessionPage";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/devices"
          element={
            <RequireAuth>
              <DeviceListPage />
            </RequireAuth>
          }
        />
        <Route
          path="/enrollment"
          element={
            <RequireAuth>
              <EnrollmentPage />
            </RequireAuth>
          }
        />
        <Route
          path="/session/:sessionId"
          element={
            <RequireAuth>
              <SessionPage />
            </RequireAuth>
          }
        />
        <Route path="/" element={<Navigate to="/devices" replace />} />
        <Route path="*" element={<Navigate to="/devices" replace />} />
      </Routes>
    </AuthProvider>
  );
}
